module.exports = __webpack_public_path__ + "static/media/mapfre-logo.9d3e13ad.jpg";